
const setKey = (arr, key) => {
    for (const item of arr) {
        item.key = item[key]
    }
}

const fillZero = (num) => {
    let s = num.toString();
    if (s.length === 1) {
        s = '0' + s
    }
    return s
}

const arrRemove = (arr, func) => {
    arr.forEach((item, i) => {
        if (func(item)) {
            arr.splice(i, 1)
        }
    })
}

const divide1toPct = (a, b) => {
    if (b === 0) {
        return 0.0
    }
    return Math.ceil(a / b * 1000) / 10
}

const getHandleNumber = (handle) => {
    return handle.substr(handle.lastIndexOf('-') + 1)
}


const globalData = (key, value) => {
    if (key) {
        if (value === null) {
            localStorage.removeItem(key)
        }
        if (value) {
            localStorage.setItem(key, JSON.stringify(value))
        } else {
            return JSON.parse(localStorage.getItem(key))
        }
    }
}

const handleRank = (list) => {

    if (list.length === 0) {
        return
    }

    let s = list[0].mmr
    let r = 1
    let i = 0
    for (const p of list) {
        i++
        if (p.mmr < s) {
            r = i
            s = p.mmr
        }
        p.rank = r
    }
}

const str2Timestamp = (str) => {
    return new Date(Date.parse(str)).getTime()
}

async function hmacSha256(secret, message) {
    const enc = new TextEncoder();
    const key = await crypto.subtle.importKey(
        "raw",
        enc.encode(secret),
        { name: "HMAC", hash: "SHA-256" },
        false,
        ["sign"]
    );

    const signature = await crypto.subtle.sign("HMAC", key, enc.encode(message));
    return Array.from(new Uint8Array(signature))
        .map(b => b.toString(16).padStart(2, "0"))
        .join("")
        .toUpperCase()
        .substring(0, 6); // 前6位和后端一致
}

// 验证激活码是否有效
async function isValidCode(code, secret = "jkfjqwiurrk") {
    try {
        const [time36, rand36, days36, sign] = code.split("-");
        const timestamp = parseInt(time36, 36);
        const rand = parseInt(rand36, 36);
        const days = parseInt(days36, 36);

        const data = `${timestamp}-${rand}-${days}`;
        const expectedSign = await hmacSha256(secret, data);

        if (expectedSign !== sign) return false;

        const now = Math.floor(Date.now() / 1000);
        return now <= timestamp + days * 86400; // 秒
    } catch (error) {
        return false;
    }
}

// 获取过期时间
function getExpireTime(code) {
    try {
        const [time36, , days36] = code.split("-");
        const timestamp = parseInt(time36, 36);
        const days = parseInt(days36, 36);
        return new Date((timestamp + days * 86400) * 1000);
    } catch (e) {
        return null;
    }
}

function diffDaysHours(date1, date2) {
    // 转换为时间戳（毫秒）
    const t1 = new Date(date1).getTime();
    const t2 = new Date(date2).getTime();

    // 计算差值，绝对值避免负数
    // let diff = Math.abs(t1 - t2);
    let diff = t1 - t2;

    const msPerDay = 24 * 60 * 60 * 1000;
    const msPerHour = 60 * 60 * 1000;

    const days = Math.floor(diff / msPerDay);
    diff -= days * msPerDay;

    const hours = Math.floor(diff / msPerHour);

    return { days, hours };
}

// 示例用法
// (async () => {
//     const code = "TBMT3I-34Z-U-DF0522"; // 后端生成的
//     const secret = "jkfjqwiurrk";
//
//     console.log("有效吗？", await isValidCode(code, secret));
//     console.log("过期时间：", getExpireTime(code));
// })();

export {
    setKey,
    fillZero,
    globalData,
    arrRemove,
    divide1toPct,
    getHandleNumber,
    handleRank,
    str2Timestamp,
    isValidCode,
    getExpireTime,
    diffDaysHours
}
